<router-outlet></router-outlet>
<app-active-call-overlay></app-active-call-overlay>

<!-- Initialize Template Service -->
<app-template-service></app-template-service>
